import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/components/Logo";
import { Turnstile, TURNSTILE_ENABLED } from "@/components/Turnstile";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [resetSignal, setResetSignal] = useState(0);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (TURNSTILE_ENABLED && !token) {
      setError("Please complete the human verification.");
      return;
    }
    setLoading(true);
    try {
      await login(username, password, token);
      navigate("/admin");
    } catch (err) {
      setError(err?.message || "Login failed");
      setResetSignal((n) => n + 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white border border-gray-100 shadow-sm p-8">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Zebaa" className="h-8 w-auto object-contain mx-auto" />
          <p className="text-xs uppercase tracking-[0.2em] text-gray-400 mt-4">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wide text-gray-500">Username</label>
            <input autoComplete="username" autoCapitalize="none" spellCheck={false} value={username} onChange={(e) => setUsername(e.target.value)} data-testid="admin-username"
              className="mt-1 w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-pink" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide text-gray-500">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
              className="mt-1 w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-pink" />
          </div>
          {error && <p className="text-sm text-pink" data-testid="admin-login-error">{error}</p>}
          <Turnstile onVerify={setToken} action="admin-login" resetSignal={resetSignal} />
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-pink text-white py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            <Lock className="w-4 h-4" /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
